// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__2CrL7","form":"EditListingDescriptionPanel_form__zFheu","title":"EditListingDescriptionPanel_title__1Pqg9"};